import { combineReducers } from 'redux'
import { Reducer as redirect } from '@myxplor/notifications-redux'
import { Reducer as auth_personnel } from './auth-personnel'

// registration
import { Reducer as gov_care_registration } from './registration'
import { Reducer as gov_care_registration_details } from './gov-care-registration-details'

import { Reducer as authorisation } from './authorisation'
import { Reducer as active_filter } from './ui/active-filter'
import { Reducer as current_reg_holder } from './layout'


export default combineReducers({
  redirect,
  authorisation,
  auth_personnel,
  gov_care_registration,
  gov_care_registration_details,
  active_filter,
  current_reg_holder
})


// WEBPACK FOOTER //
// ./src/reducer.js